import request from '@/utils/request'

// 获取新人礼配置
export function getNewGiftConfig() {
  return request({
    url: '/biz/admin/user/newGiftConfig/detail',
    method: 'get'
  })
}

// 保存/修改新人礼配置
export function saveNewGiftConfig(data) {
  return request({
    url: '/biz/admin/user/newGiftConfig/saveOrEdit',
    method: 'post',
    data: data
  })
}
